import { render, staticRenderFns } from "./patientPortalLetter.vue?vue&type=template&id=145f0dee&"
import script from "./patientPortalLetter.vue?vue&type=script&lang=js&"
export * from "./patientPortalLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports